var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 6 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.87,
    d: "m.596 8.43.737.737L5.5 5 1.333.833l-.737.738L4.025 5z"
  })));
};
export default SvgRightArrow;